import type { SVGProps } from "react";

export function CheckfrontIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16.4 33.6L12 37.9L32.2 57.6L66.4 11.1C65.8 8.4 63.5 6.4 60.7 6.2L30.1 38.5L16.4 33.6Z" fill="#F5F9FD" />
      <path d="M32.1 57.5L12.3 38.2L32.1 57.5Z" fill="white" />
      <path
        d="M66.5 60.3V12.4C66.5 11.9 66.3999 11.4 66.2999 11L32.1 57.5L12.3 38.1H12.2L26.9 66.6H60.2C63.6 66.6 66.5 63.8 66.5 60.3Z"
        fill="url(#checkfront-paint0)"
      />
      <path
        d="M66.5001 60.3V12.4C66.5001 11.9 66.4001 11.4 66.3001 11L32.1001 57.5L37.6001 66.6H60.1001C63.6001 66.6 66.5001 63.8 66.5001 60.3Z"
        fill="url(#checkfront-paint1)"
      />
      <path
        d="M12.3 6.1C8.8 6.1 6 9 6 12.4V60.3C6 63.8 8.9 66.6 12.3 66.6H26.9L12.2 38.1H12.3L12 37.8L16.4 33.5L30 38.3L60.6 6C60.5 6 60.3 6 60.2 6L12.3 6.1Z"
        fill="#3084C6"
      />
      <defs>
        <linearGradient
          id="checkfront-paint0"
          x1="54.1273"
          y1="53.1969"
          x2="38.7176"
          y2="23.7239"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E74BB" />
          <stop offset="1" stopColor="#1266A7" />
        </linearGradient>
        <linearGradient
          id="checkfront-paint1"
          x1="44.4042"
          y1="25.5805"
          x2="61.7376"
          y2="56.9139"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2777B2" />
          <stop offset="1" stopColor="#287ABF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
